import './ProjectListItemMembers.scss';
import React, { memo } from 'react';
import { Avatar } from 'src/modules/common/components/Avatar';
import { ProjectOwner } from 'src/modules/common/types/ProjectOwner';
import { HelperText01 } from 'src/modules/common/typography/HelperText01';

type Props = {
  readonly owner: ProjectOwner | null;
  readonly members: number;
};

export const ProjectListItemMembers = memo(({ owner, members }: Props) => (
  <div className="bp-project-list-item-members">
    {owner ? <Avatar user={owner}/> : null}

    {members > 0 ? (
      <div className="bp-project-list-item-members__number">
        <HelperText01>
          +{members}
        </HelperText01>
      </div>
    ) : null}
  </div>
));
